import SpriteSymbol from "../../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ntpd_press",
  "use": "ntpd_press-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"ntpd_press\"><path d=\"M15.25 14.5h-4.74c-.13-.39-.4-.71-.76-.91v-.65A5.998 5.998 0 009 .99C5.69.99 3 3.69 3 7c0 3.06 2.29 5.58 5.25 5.95v.65c-.36.19-.63.51-.76.91H2.75c-.41 0-.75.34-.75.75s.34.75.75.75h5.01c.29.36.74.6 1.24.6s.95-.24 1.24-.6h5.01c.41 0 .75-.34.75-.75s-.34-.76-.75-.76zm-7-7.19V4.5c0-.41.34-.75.75-.75s.75.34.75.75v2.19l.8.8c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22L8.25 7.31z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol